import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { FloatInput } from 'ui-components/components/float-input';
import { Button } from 'ui-components/components/button';
import LocalePicker from '../locale-picker';

import style from './resend-verification-form.module.css';
import messages from './messages';

const ResendVerificationForm = ({ onResendVerificationClick }) => {
  const [email, setEmail] = useState();
  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [sentEmailSuccessfully, setSentEmailSuccessfully] = useState(false);

  const onEmailChange = useCallback((newEmail) => {
    setEmail(newEmail);
  }, []);

  const onSendError = useCallback(() => {
    setErrorMsg(messages.verifyErrorMessage);
    setSendButtonDisabled(false);
  }, []);

  const onSendSuccess = useCallback(() => {
    setSentEmailSuccessfully(true);
    setSendButtonDisabled(true);
  }, []);

  const onSendClick = useCallback(() => {
    onResendVerificationClick(email, onSendSuccess, onSendError);
    setErrorMsg(null);
    setSendButtonDisabled(true);
  }, [email, onResendVerificationClick, onSendSuccess, onSendError]);

  const renderError = () => {
    if (!errorMsg) {
      return null;
    }
    return (
      <div className={style['error-message']}>
        <FormattedMessage {...errorMsg} />
      </div>
    );
  };

  const renderSendSuccess = () => {
    if (!sentEmailSuccessfully) {
      return null;
    }

    return (
      <div className={style['successfully-sent-message']}>
        <FormattedMessage {...messages.emailSentSuccess} />
      </div>
    );
  };

  return (
    <div className={style['resend-verification-form']}>
      <div className={style['resend-verification-form-title']}>
        <FormattedMessage {...messages.title} />
      </div>
      {renderError()}
      {renderSendSuccess()}
      <div className={style['form-inputs']}>
        <FloatInput autoFocus label={<FormattedMessage {...messages.emailInputLabel} />} onChange={onEmailChange} value={email} />
      </div>
      <div className={style['resend-verification-buttons']}>
        <Button disabled={sendButtonDisabled} onClick={onSendClick} theme='primary'>
          <FormattedMessage {...messages.sendButtonText} />
        </Button>
      </div>
      <footer>
        <Button className={style['text-link']} href='/login' target='' theme='link'>
          <FormattedMessage {...messages.returnToLogin} />
        </Button>
        <LocalePicker />
      </footer>
    </div>
  );
};

ResendVerificationForm.propTypes = {
  onResendVerificationClick: PropTypes.func.isRequired,
};

export default ResendVerificationForm;
